import React, { useContext, useEffect } from "react";
import _ from "lodash"

import { Column, Grid, Row } from "carbon-components-react";
import MainContext from "context/MainContext";
import MainContent from "components/MainContent";


const AboutLayout = (props) => {

    const context = useContext(MainContext)

    useEffect(() => {
        context.setEvent()
    }, [])

    return (
        <MainContent narrow={false}>
            <Grid>
                <Row>
                    <Column>
                        Build: {process.env.AWS_JOB_ID}
                    </Column>
                </Row>
                <Row>
                    <Column>
                        Commit: {process.env.AWS_COMMIT_ID}
                    </Column>
                </Row>
            </Grid>
        </MainContent>
    );
};

export default AboutLayout;
